import { useNavigate } from "react-router-dom";
import { Button } from "primereact/button";
import { RootState } from "../../app/store";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import './authent.scss'

export function Authent() {
  const { t } = useTranslation();
  const authParams = useSelector(
    (state: RootState) => state.app.authParams
  );
  const navigate = useNavigate();

  return (
    <div className="m-5 auth-container">
      <b className="block mb-3">{t("title.authPage")}</b>
      <Button
        className="p-button-text tight-button"
        label="Keycloak"
        icon="pi pi-cog"
        onClick={() => {
          var url = new URL(authParams.oauth2_login_url);
          var c = url.searchParams.get('redirect_uri');
          c = c + `?frontlocation=${ window.location.protocol + "//" + window.location.host + "/dashboard" }`;
          // redirect to login interface of keycloack
          url.searchParams.set('redirect_uri', encodeURI(c));
          window.location.href = url.toString();
        }}
      />
      <Button
        className="p-button-text tight-button"
        label={t("button.authBasic")}
        icon="pi pi-cog"
        onClick={() => {
          navigate("/basicauth");
        }}
      />
    </div>
  );
}
